export default function attachOpenCookieSettings() {
	const links = document.querySelectorAll('.open-cookie-settings');
	links.forEach((link) => {
		link.addEventListener('click', (event) => {
			event.preventDefault();
			window.OneTrust?.ToggleInfoDisplay();
		});
	});
}
